import * as React from 'react';
import { Box, Button, Card, Checkbox, Grid, Input, Link, Stack, Table, Typography } from "@mui/joy"
import { interpolarCor } from "../core/helpers"
import { useDispatch, useSelector } from "react-redux"
import { triggerChangeNome, triggerLoadDados, triggerTrocaFiltroRelatorio, triggerTrocaRelatorio } from "./EstoqueSlice"
import { v4 } from "uuid"
import LoadingScreen from '../core/components/LoadingScreen';

var linkStyle = (e) => {

    var style = {
        textDecoration: "underline"
    }

    if (e == 1 || e == 2) style['color'] = "#fff"

    return style
}
var tableRowStyle = (e, ehFornecedor) => {

    var bg = "rgb(221, 231, 238)"
    var color = "rgb(23, 26, 28)"

    var build = (bg, color) => {
        return {
            background: bg,
            color: color
        }
    }

    if (e != 3) {

        if (e == 0 || (ehFornecedor && e == 1))
            return build("#c20000", "#fff")
        if (e == 5)
            return build("rgb(14,13,13)", "#fff")
        if (e == 1)
            return build("rgb(217, 99, 13)", "#fff")
        if (e == 2)
            return build("rgb(194,172,0)", "#fff")
        if (e == 4)
            return build("rgb(73,100,239)", "#fff")
    }

    if (e.index % 2 == 0)
        return build(bg, color)

    return build("#fefefe", "rgb(23,26,28)")
}

function BarraPerformance(props) {

    var percent = props.percent

    if (percent == null) percent = 5

    var dpercent = percent.toFixed(1)

    return <Stack>
        <Box sx={{
            border: "1px solid black",
            width: "60px",
            height: "280px"
        }}>
            <Box sx={{
                width: "100%",
                height: (100 - percent) + "%",
                textAlign: "center",
                display: "block",
                position: "relative"
                // display: "flex",
            }}>
                {percent < 90 && <Box
                    sx={{
                        position: "absolute",
                        bottom: "0",
                        left: "20%"
                    }}>
                    {dpercent}%
                </Box>}
            </Box>
            <Box sx={{
                background: interpolarCor(percent),
                width: "100%",
                height: percent + "%",
                display: "block",
                position: "relative",
                boxSizing: "border-box",
                boxShadow: "0 1px 0 0 #777777 inset"
            }}>
                {percent >= 90 && <Box
                    sx={{
                        position: "absolute",
                        top: "0",
                        left: "20%",
                        color: "white"
                    }}>
                    {dpercent}%
                </Box>}
            </Box>
        </Box>
    </Stack>
}
function BarraCurvas(props) {


    var a = props.porcentagens.a.toFixed(1)
    var b = props.porcentagens.b.toFixed(1)
    var c = props.porcentagens.c.toFixed(1)
    var d = (100 - (props.porcentagens.a + props.porcentagens.b + props.porcentagens.c)).toFixed(1)

    function BoxCurva(props) {
        return <Box sx={{
            background: props.bg,
            width: "100%",
            height: props.valor + "%",
            display: "block",
            position: "relative",
            boxSizing: "border-box",
            // boxShadow: "0 1px 0 0 #777777 inset"
        }}>
            <Box
                sx={{
                    position: "absolute",
                    top: "0",
                    left: "20%",
                    color: "white"
                }}>
                {props.valor > 7 && props.valor + "%"}
            </Box>
        </Box>
    }

    return <Stack>
        <Box sx={{
            border: "1px solid black",
            width: "60px",
            height: "280px"
        }}>
            <BoxCurva valor={a} bg={"#439b07"} />
            <BoxCurva valor={b} bg={"#30bb09"} />
            <BoxCurva valor={c} bg={"#5bd508"} />
            <BoxCurva valor={d} bg={"#333"} />
        </Box>
    </Stack>
}
function DistribuicaoEstoque(props) {

    function Row({ component: Component, ...props }) {

        return <Card sx={{
            padding: "5px 10px",
            background: props.bg ? props.bg : "rgb(251, 252, 254)",
            color: props.color ? props.color : "rgb(50, 56, 62)",
            border: props.round == false ? "0" : "1px solid #CDD7E1",
            textAlign: props.center ? "center" : "",
            width: props.width ? "100%" : "auto",
        }}>
            {props.text && props.link ? <Link sx={{
                color: props.color ? props.color : "rgb(6, 98, 191)",
                textDecoration: "underline"
            }}
                onClick={props.onClick}>{props.text}</Link> : props.text}
            {typeof (Component) !== "undefined" && <Component />}
        </Card>
    }

    return <Box>
        <Stack spacing={1}>
            <Typography>
                <b>Distribuição do estoque</b>
            </Typography>
            <Stack direction={"row"} spacing={1}>
                <Stack spacing={1} sx={{ width: "100%" }}>
                    <Row component={() => <Typography><b>Total:</b> R$ {props.distribuicao.qtde.total.toFixed(2)}</Typography>} />
                    <Stack direction={"row"} spacing={1} sx={{ width: "100%" }}>
                        <Row bg="#439b07" color="#fff" center={true} round={false} text="A" />
                        <Row width={true} link={true} text={"R$ " + props.distribuicao.qtde.a.toFixed(2)}
                            onClick={() => props.trocaRelatorio({
                                codigo: "REL_CURVA_A"
                            })} />
                    </Stack>
                    <Stack direction={"row"} spacing={1}>
                        <Row bg="#30bb09" color="#fff" center={true} round={false} text="B" />
                        <Row width={true} link={true} text={"R$ " + props.distribuicao.qtde.b.toFixed(2)}
                            onClick={() => props.trocaRelatorio({
                                codigo: "REL_CURVA_B"
                            })} />
                    </Stack>
                    <Stack direction={"row"} spacing={1}>
                        <Row bg="#5bd508" color="#fff" center={true} round={false} text="C" />
                        <Row width={true} link={true} text={"R$ " + props.distribuicao.qtde.c.toFixed(2)}
                            onClick={() => props.trocaRelatorio({
                                codigo: "REL_CURVA_C"
                            })} />
                    </Stack>
                    <Stack direction={"row"} spacing={1}>
                        <Row bg="#333" color="#fff" center={true} round={false} text="D" />
                        <Row width={true} link={true} color="#c20000" text={"R$ " + props.distribuicao.qtde.d.toFixed(2)}
                            onClick={() => props.trocaRelatorio({
                                codigo: "REL_LIQUIDACOES"
                            })} />
                    </Stack>
                </Stack>
                <Stack spacing={1} sx={{ width: "100%" }}>
                    <Row component={() => <Typography><b>Giro:</b> 	R$ {props.distribuicao.giro.total.toFixed(2)}</Typography>} />
                    <Stack direction={"row"} spacing={1} sx={{ width: "100%" }}>
                        <Row width={true} text={"R$ " + props.distribuicao.giro.a.toFixed(2) + " (" + props.distribuicao.duracao.a.toFixed(0) + " dias)"} />
                    </Stack>
                    <Stack direction={"row"} spacing={1}>
                        <Row width={true} text={"R$ " + props.distribuicao.giro.b.toFixed(2) + " (" + props.distribuicao.duracao.b.toFixed(0) + " dias)"} />
                    </Stack>
                    <Stack direction={"row"} spacing={1}>
                        <Row width={true} text={"R$ " + props.distribuicao.giro.c.toFixed(2) + " (" + props.distribuicao.duracao.c.toFixed(0) + " dias)"} />
                    </Stack>
                    <Stack direction={"row"} spacing={1}>
                        <Row width={true} text="-" />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    </Box>
}
function DescricaoPerformance(props) {

    function Row(props) {

        return <Card sx={{
            padding: "5px 10px",
            background: props.bg ? props.bg : "rgb(251, 252, 254)",
            color: props.color ? props.color : "rgb(50, 56, 62)",
            border: "1px solid #CDD7E1"
        }}>
            {props.text}
        </Card>
    }

    return <Box sx={{ width: "100%" }}>
        <Stack spacing={1}>
            <Typography>
                <b>Desempenho do estoque</b>
            </Typography>
            <Row color="#c20000" text={props.problemas.vazio.toFixed(1) + "% Estoque vazio"} />
            <Row text={props.problemas.baixo.toFixed(1) + "% Estoque baixo"} />
            <Row text={props.problemas.alto.toFixed(1) + "% Estoque Alto"} />
            <Row text={props.problemas.encalhado.toFixed(1) + "% Estoque Encalhado"} />
        </Stack>
    </Box>
}
function DescricaoAcoes(props) {

    var trocaRelatorio = props.trocaRelatorio

    function Row(props) {

        return <Card sx={{
            padding: "5px 10px",
            background: props.bg ? props.bg : "rgb(251, 252, 254)",
            border: "1px solid #CDD7E1"
        }}>
            <Link sx={{
                textDecoration: "underline",
                color: props.color ? props.color : "rgb(6, 98, 191)",
            }} onClick={props.onClick}>{props.text}</Link>
        </Card>
    }

    return <Box sx={{ width: "100%" }}>
        <Stack spacing={1}>
            <Typography>
                <b>Ações</b>
            </Typography>
            <Row color="#c20000" text={"R$" + (props.acoes.compra.critica / 1000).toFixed(1) + "k crítico - Sugestões de compra"}
                onClick={() => trocaRelatorio({
                    codigo: "REL_SUGESTAO_COMPRA"
                })} />

            <Row text={"R$" + (props.acoes.compra.risco / 1000).toFixed(1) + "k em risco - Sugestões de compra"}
                onClick={() => trocaRelatorio({
                    codigo: "REL_SUGESTAO_COMPRA"
                })} />

            <Row text={"R$" + (props.acoes.venda.promocao / 1000).toFixed(1) + "k Promoções"}
                onClick={() => trocaRelatorio({
                    codigo: "REL_PROMOCOES"
                })} />

            <Row color="#c20000" text={"R$" + (props.acoes.venda.liquidacao / 1000).toFixed(1) + "k Liquidações"}
                onClick={() => trocaRelatorio({
                    codigo: "REL_LIQUIDACOES"
                })} />

        </Stack>
    </Box>
}
function ResultadoPorProduto(props) {

    var data = props.produtos
    var trocaOrdencao = (id) => {

        var ordem = {
            "codigo": id,
            "label": "Sem label"
        }

        switch (id) {
            case 'LUCRO':
                ordem.label = "Maior retorno mensal"
                break
            case 'CUSTO':
                ordem.label = "Maior custo do estoque"
                break
            case 'NOME':
                ordem.label = "Nome"
                break
            case 'PERDA':
                ordem.label = "Perda de desempenho estimada"
                break
            case 'SITUACAO':
                ordem.label = "Situação em ordem alfabetica"
                break
        }

        props.dispatch(triggerTrocaFiltroRelatorio({
            "nome": "ordem",
            "value": ordem
        }))

    }

    return <Grid xs={12}>
        <Table size="small" aria-label="table" >
            <thead>
                <tr>
                    <th style={{ width: "40px", textAlign: "left" }} title="Index - Ordem de importancia">Idx</th>
                    <th style={{ width: "20px", textAlign: "left" }} title="Curva">C</th>
                    <th style={{ width: "100px", textAlign: "left" }}>
                        <Link
                            onClick={() => trocaOrdencao("LUCRO")}
                            title="Lucro mensal estimado">Lucro Men.</Link>
                    </th>
                    <th style={{ width: "100px", textAlign: "left" }}><Link
                        onClick={() => trocaOrdencao("CUSTO")}
                        title="Estimativa de custo total">Est. Custo</Link></th>
                    <th style={{ width: "80px", textAlign: "left" }} title="Estoque atual / Estoque sugerido minimo">Estoque</th>
                    <th style={{ width: "80px", textAlign: "left" }} title="Compra minima melhor retorno / compra maxima">Compra</th>
                    <th style={{ width: "80px", textAlign: "left" }} title="Situação de eficiência do estoque"><Link
                        onClick={() => trocaOrdencao("SITUACAO")}>Situação</Link></th>
                    <th style={{ width: "80px", textAlign: "left" }} title="(L) = Lucro,(O) = Oportunidade, Perda estimada">
                        <Link
                            onClick={() => trocaOrdencao("PERDA")}>Perda</Link>

                    </th>
                    <th style={{ width: "80px", textAlign: "left" }} title="Quantos dias o estoque atual ainda dura">Duração</th>
                    <th style={{ textAlign: "left" }}>
                        <Link
                            onClick={() => trocaOrdencao("NOME")}>Nome</Link>
                    </th>
                </tr>
            </thead>
            <tbody>
                {data
                    .map(e => {
                        return <tr key={v4()} style={tableRowStyle(e.situacao.nivel)}>
                            <td>{e.index}</td>
                            <td>{e.curva}</td>
                            <td>{"R$ " + e.retornoMensal.toFixed(2)}</td>
                            <td>{"R$ " + e.estoque.custo.toFixed(2)}</td>
                            <td>{e.estoque.atual.toFixed(0)} / {e.estoque.sugerido.toFixed(0)}</td>
                            <td>{e.estoque.compra.minima.toFixed(0)} / {e.estoque.compra.maxima.toFixed(0)}</td>
                            <td>{e.situacao.label}</td>
                            <td>{
                                e.perdas.lucro > 0 ?
                                    "L " + e.perdas.lucro.toFixed(0)
                                    : e.perdas.oportunidade > 0
                                        ? "O " + e.perdas.oportunidade.toFixed(1) : ""}</td>
                            <td>{e.estoque.duracao > 0 ? Math.ceil(e.estoque.duracao).toFixed(0) + " dias" : "-"}</td>
                            <td style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }} title={e.descricao}>{e.descricao}</td>
                        </tr>
                    })}
            </tbody>
        </Table>
    </Grid>
}
function ResultadoPorFornecedor(props) {

    var data = props.fornecedores

    return <Grid xs={12}>
        <Table size="small" aria-label="table" >
            <thead>
                <tr>
                    <th style={{ width: "40px", textAlign: "left" }} title="Index - Ordem de importancia">Idx</th>
                    <th style={{ width: "50px", textAlign: "left" }} title="Contribuição para o indicador de performance">Perf.</th>
                    <th style={{ width: "110px", textAlign: "left" }} title="Estoque vazio ou acabando que precisa ser reposto">Urgência</th>
                    <th style={{ width: "110px", textAlign: "left" }} title="Estoque abaixo de 20 dias">Atenção</th>
                    <th style={{ width: "110px", textAlign: "left" }} title="Estoque acima de 2 meses">Excesso</th>
                    <th style={{ width: "110px", textAlign: "left" }} title="Estoque Encalhado">Encalhado</th>
                    <th style={{ width: "110px", textAlign: "left" }} title="Sugestão de compra">Sugestão</th>
                    <th style={{ width: "110px", textAlign: "left" }} title="Situação da reposição">Situação</th>
                    <th style={{ textAlign: "left" }}>
                        <Link onClick={() => {
                            props.dispatch(triggerTrocaFiltroRelatorio({
                                "nome": "ordem",
                                "value": {
                                    "codigo": "NOME",
                                    "label": "Nome"
                                }
                            }))
                        }}>Nome</Link>
                    </th>
                </tr>
            </thead>
            <tbody>
                {data
                    .map(e => {

                        return <tr key={v4()} style={tableRowStyle(e.situacao.nivel, true)}>
                            <td>{e.index}</td>
                            <td>{(e.performance.lucro * 100).toFixed(1)}%</td>
                            <td>R$ {e.estoques.urgencia.toFixed(2)}</td>
                            <td>R$ {e.estoques.atencao.toFixed(2)}</td>
                            <td>R$ {e.estoques.excesso.toFixed(2)}</td>
                            <td>R$ {e.estoques.encalhado.toFixed(2)}</td>
                            <td>R$ {e.estoques.sugestao.toFixed(2)}</td>
                            <td>{e.situacao.label}</td>
                            <td style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }} title={e.descricao}>
                                <Link style={linkStyle(e.situacao.nivel)}
                                    onClick={() => {
                                        props.trocaRelatorio({
                                            codigo: "REL_PROD_FORN",
                                            id: e.codigo
                                        })
                                    }}
                                >{e.descricao}</Link>
                            </td>
                        </tr>
                    })}
            </tbody>
        </Table>
    </Grid>
}
function EstoqueDashboard() {

    var dispatch = useDispatch()
    var loading = useSelector((state) => state.estoque.loading)
    var relatorio = useSelector((state) => state.estoque.relatorio)
    var data = useSelector(state => state.estoque.data)
    var versao = useSelector(state => state.estoque.versao)
    var desempenho = useSelector((state) => state.estoque.desempenho)
    var distribuicao = useSelector((state) => state.estoque.distribuicao)
    var produtos = useSelector((state) => state.estoque.produtosExpostos)
    var fornecedores = useSelector((state) => state.estoque.fornecedoresExpostos)
    var filtros = useSelector((state) => state.estoque.filtros)
    var metricas = useSelector((state) => state.estoque.metricas)

    var trocaRelatorio = (codigo) => {
        dispatch(triggerTrocaRelatorio(codigo))
    }

    React.useEffect(() => {
        dispatch(triggerLoadDados())
    }, []);

    var changeNome = (e) => {
        dispatch(triggerChangeNome(e.target.value))
    }

    var toggleMostrarSomenteCompras = () => {
        dispatch(triggerTrocaFiltroRelatorio({
            "nome": "somenteCompras",
            "value": !filtros.somenteCompras
        }))
    }


    if (loading) {
        return <LoadingScreen />
    }

    return <>
        <Grid xs={12} sx={{ padding: "5px 0" }}>
            <Stack direction={"row"} spacing={2}>
                <Typography sx={{ fontSize: "12px" }}><b>Publicação:</b> {data} (V{versao})</Typography>
            </Stack>
        </Grid>
        <Grid xs={6} sx={{ paddingRight: "10px" }} >
            <Grid container spacing={1}>
                <Grid xs={"auto"}>
                    <BarraPerformance percent={desempenho.percentual} />
                </Grid>
                <Grid xs={true}>
                    <DescricaoPerformance problemas={desempenho.problemas} />
                </Grid>
                <Grid xs={true}>
                    <DescricaoAcoes acoes={desempenho.acoes} trocaRelatorio={trocaRelatorio} />
                </Grid>
            </Grid>
        </Grid>
        <Grid xs={6}>
            <Grid container spacing={1} sx={{ width: "100%" }}>
                <Grid xs={"auto"}>
                    <BarraCurvas porcentagens={distribuicao.porcentagem} />
                </Grid>
                <Grid xs={true}>
                    <DistribuicaoEstoque distribuicao={distribuicao} trocaRelatorio={trocaRelatorio} />
                </Grid>
            </Grid>
        </Grid>
        <Grid xs={12} sx={{ paddingTop: "10px" }}>
            <Stack direction={"row"} spacing={1} >
                <Stack spacing={0.25}>
                    <Typography><b>Relatório:</b> {relatorio.descricao}</Typography>
                    <Typography><b>Listando:</b> {filtros.listagem == "PRODUTO" ? "Produtos" : "Fornecedores"}  </Typography>

                    <Typography><b>Ordenando por:</b> {filtros.ordem.label} </Typography>
                    <Checkbox
                        checked={filtros.somenteCompras === true}
                        onClick={toggleMostrarSomenteCompras} label="Mostrar somente produtos para comprar" />
                </Stack>
            </Stack>
        </Grid>
        <Grid xs={12} sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <Input type="text" placeholder='Nome...' onChange={changeNome}></Input>
        </Grid>
        <Grid xs={12} sx={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <Stack direction={"row"} spacing={1}>

                <Typography><b>#Items</b>: {metricas.numeroItems}</Typography>

                {metricas.nomeFornecedor !== null &&
                    <>
                        <Typography><b>Fornecedor</b>: {metricas.nomeFornecedor}</Typography>
                        <Link onClick={() => trocaRelatorio({
                            codigo: "REL_SUGESTAO_COMPRA"
                        })}>[trocar]</Link>
                    </>}
            </Stack>
        </Grid>
        {filtros.listagem == "PRODUTO" && <ResultadoPorProduto produtos={produtos}
            nome={filtros.nome}
            somenteVendas={filtros.somenteCompras}
            dispatch={(event) => dispatch(event)} />}
        {filtros.listagem == "FORNECEDOR" && <ResultadoPorFornecedor
            fornecedores={fornecedores}
            nome={filtros.nome}
            trocaRelatorio={trocaRelatorio}
            dispatch={(event) => dispatch(event)} />}
    </>
}


export default EstoqueDashboard